import React from "react";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";

// Content lives in SECTIONS; strings support <b>bold</b>, lists use { list: [...] }.

const LAST_UPDATED = "2026. június";

const SECTIONS = [
  {
    id: "adatkezelo-adatai",
    title: "1. Az adatkezelő adatai",
    paragraphs: [
      "A jelen adatkezelési tájékoztató (a továbbiakban: „Tájékoztató”) bemutatja, hogyan kezeli az adatkezelő a www.szasztotheniko.com weboldalon keresztül megadott személyes adatokat.",
      { list: [
        "Név: Szász-Tóth Enikő",
        "Minőség: magánszemély",
        "Postai cím: 4002 Debrecen, Kárpáti Károly utca 3.",
        "E-mail: szasztotheniko.office@gmail.com",
        "Telefon: +36 20 266 7599",
        "Weboldal: www.szasztotheniko.com",
      ]},
      "Az adatkezelő az Európai Parlament és a Tanács (EU) 2016/679 rendelete (általános adatvédelmi rendelet, a továbbiakban: GDPR), valamint a hatályos magyar jogszabályok szerint jár el.",
    ],
  },
  {
    id: "programjelentkezes",
    title: "2. Jelentkezés az aktuális programokra és várólista",
    paragraphs: [
      "Az „Aktuális programok” oldalon az érintett egy konkrét program meghatározott időpontjára jelentkezhet. Ha az adott időpont betelt, de a jelentkezés egyébként nyitott, az érintett várólistára jelentkezhet.",
      "<b>Kezelt adatok:</b>",
      { list: [
        "név és e-mail-cím;",
        "a választott program és időpont;",
        "az érintett által önkéntesen megadott üzenet;",
        "a jelentkezés azonosítója, beérkezésének időpontja és státusza (pl. új, fizetési információ elküldve, fizetve, lemondva, várólista);",
        "az adatkezelő által a jelentkezéshez fűzött belső megjegyzés.",
      ]},
      "<b>Az adatkezelés célja:</b> a jelentkezés fogadása és nyilvántartása, a létszám kezelése, a jelentkezővel való kapcsolattartás (pl. fizetési információ, a programmal kapcsolatos tájékoztatás), a várólistán szereplők megkeresése felszabaduló hely esetén, valamint a program lebonyolítása.",
      "<b>Jogalap:</b> a GDPR 6. cikk (1) bekezdés b) pontja – az érintett kérésére a szerződés megkötését megelőző lépések megtétele, illetve a szerződés teljesítése.",
      "A várólistára történő jelentkezés nem jelent helyfoglalást. A várólistán szereplő jelentkezőt az adatkezelő egyedileg keresi meg, ha hely szabadul fel; automatikus átsorolás nem történik.",
      "Új jelentkezés beérkezésekor a rendszer értesítő e-mailt küld az adatkezelőnek, amely a jelentkező nevét, e-mail-címét, a választott időpontot és az esetleges üzenetet tartalmazza.",
      "A program jellegéből adódóan előfordulhat, hogy az érintett az üzenetében saját élethelyzetére vonatkozó információt oszt meg. Ezeket az adatkezelő bizalmasan kezeli, és kizárólag a jelentkezés kezeléséhez használja fel.",
    ],
  },
  {
    id: "elmenyprogram",
    title: "3. Jelentkezés az élményprogramra",
    paragraphs: [
      "<b>Kezelt adatok:</b> teljes név, e-mail-cím, telefonszám, a motivációra, a kívánt változásra és egyéb megjegyzésekre adott válaszok, a jelentkezés azonosítója és beérkezésének időpontja, valamint a marketingcélú megkeresésre adott hozzájárulás ténye.",
      "<b>Az adatkezelés célja:</b> a jelentkezés fogadása és feldolgozása, a jelentkezővel való kapcsolattartás, a részvételi díj elszámolása és a program lebonyolítása.",
      "<b>Jogalap:</b> a GDPR 6. cikk (1) bekezdés b) pontja – a szerződés megkötését megelőző lépések megtétele, illetve a szerződés teljesítése. A marketingcélú megkeresés jogalapja az érintett hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont), amely bármikor visszavonható.",
      "Az űrlap egészségi állapotra vagy más különleges adatra nem kérdez rá. Kérjük, a szabad szöveges mezőkben ilyen adatot csak akkor osszon meg, ha azt feltétlenül szükségesnek érzi.",
      "Új jelentkezés beérkezésekor a rendszer értesítő e-mailt küld az adatkezelőnek a jelentkezés adataival. A jelentkező automatikus visszaigazoló e-mailt nem kap; a sikeres beküldésről a weboldalon kap visszajelzést, a további kapcsolattartás pedig személyesen, e-mailben történik.",
    ],
  },
  {
    id: "kapcsolati-urlap",
    title: "4. Kapcsolatfelvételi űrlap",
    paragraphs: [
      "<b>Kezelt adatok:</b> név, e-mail-cím és az üzenet szövege.",
      "<b>Az adatkezelés célja:</b> a megkeresés megválaszolása és az ezzel kapcsolatos kapcsolattartás. Az adatokat az adatkezelő marketingcélra nem használja fel.",
      "<b>Jogalap:</b> a GDPR 6. cikk (1) bekezdés b) pontja – az érintett kérésére a szerződés megkötését megelőző lépések megtétele.",
      "Az üzenetről az adatkezelő e-mail-értesítést kap. A rendszer emellett automatikus visszaigazoló e-mail küldését kísérelheti meg az üzenetküldő által megadott e-mail-címre; ennek kézbesítése jelenleg nem garantált.",
    ],
  },
  {
    id: "hirlevel",
    title: "5. Hírlevél-feliratkozás",
    paragraphs: [
      "A hírlevélben az adatkezelő a programjaival, írásaival és új lehetőségeivel kapcsolatos tájékoztatást küld az érintett által kiválasztott érdeklődési kör(ök) szerint.",
      "<b>Kezelt adatok:</b> e-mail-cím, az önkéntesen megadott keresztnév, a választott érdeklődési kör(ök), valamint a feliratkozás és a megerősítés ténye és időpontja.",
      "A feliratkozás kétlépcsős (ún. double opt-in): a feliratkozás csak azt követően válik érvényessé, hogy az érintett a megadott e-mail-címre küldött megerősítő levélben található linkre kattint.",
      "<b>Jogalap:</b> az érintett önkéntes, kifejezett hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont).",
      "<b>Megőrzési idő:</b> a hozzájárulás visszavonásáig. A hozzájárulás bármikor, ingyenesen visszavonható a hírlevelekben található leiratkozási linkkel vagy az adatkezelő e-mail-címére küldött üzenettel. A visszavonás nem érinti a visszavonás előtti adatkezelés jogszerűségét.",
      "A hírlevelek kiküldése a MailerLite szolgáltatásán keresztül történik (lásd 8. pont).",
    ],
  },
  {
    id: "konzultacio",
    title: "6. Konzultációs időpontfoglalás (Calendly)",
    paragraphs: [
      "A konzultációs időpontfoglalás a Calendly időpontfoglaló felületén keresztül történik. A Calendly felülete csak akkor töltődik be, amikor a látogató a weboldalon az időpontfoglalás gombra kattint. A foglaláskor megadott adatokat (pl. név, e-mail-cím, választott időpont, a foglaláshoz megadott további információk) a Calendly rögzíti, és azokat az adatkezelő a foglalás kezeléséhez, a konzultáció megszervezéséhez és a kapcsolattartáshoz használja fel.",
      "<b>Jogalap:</b> a GDPR 6. cikk (1) bekezdés b) pontja – az érintett kérésére a szerződés megkötését megelőző lépések megtétele, illetve a szerződés teljesítése.",
      "A Calendly felülete betöltéskor saját sütiket és technikai adatokat (pl. IP-cím, böngészőadatok) is kezelhet, amelyekről a Calendly adatvédelmi tájékoztatója ad részletes információt: calendly.com/legal/privacy-notice.",
    ],
  },
  {
    id: "technikai-adatok",
    title: "7. Technikai adatok és a weboldal biztonsága",
    paragraphs: [
      "A weboldal kiszolgálása során a tárhely- és hálózati szolgáltatók technikai adatokat (pl. IP-cím, böngésző típusa, a kérés időpontja) kezelhetnek a weboldal működtetése és védelme érdekében.",
      "A programjelentkezési űrlap visszaélésszerű, tömeges használatának megelőzésére a rendszer a beküldő IP-címét nem tárolja eredeti formájában, csak annak egyirányú, kódolt (hash) változatát rögzíti a beküldés időpontjával. Ezeket a bejegyzéseket a rendszer 1 óra elteltével automatikusan törli.",
      "A weboldal betűtípusai a weboldal saját tárhelyéről töltődnek be, külső betűtípus-szolgáltató igénybevétele nélkül. A weboldal látogatottságmérő vagy munkamenet-rögzítő szolgáltatást nem használ.",
      "<b>Jogalap:</b> az adatkezelő jogos érdeke a weboldal biztonságos működtetéséhez (GDPR 6. cikk (1) bekezdés f) pont).",
    ],
  },
  {
    id: "adatfeldolgozok",
    title: "8. Adatfeldolgozók",
    paragraphs: [
      "Az adatkezelő az alábbi szolgáltatók szolgáltatásait veszi igénybe. Az adatfeldolgozók a személyes adatokat az adatkezelő megbízásából, a szolgáltatás nyújtásához szükséges mértékben kezelik.",
      { list: [
        "<b>Weboldal-kiszolgálás és hálózati védelem:</b> Cloudflare, Inc. (101 Townsend St., San Francisco, CA 94107, Amerikai Egyesült Államok) – a weboldal tárhelyszolgáltatása, kiszolgálása és védelme;",
        "<b>Háttérrendszer és adatbázis:</b> Emergent (emergent.sh) – a weboldal háttérrendszerének futtatása és a jelentkezések, űrlapadatok tárolására szolgáló felügyelt adatbázis üzemeltetése. A háttérrendszer az Amazon Web Services infrastruktúráján, az Amerikai Egyesült Államokban található adatközpontban működik;",
        "<b>E-mail-küldés:</b> Plus Five Five, Inc. (Resend; 2261 Market Street #5039, San Francisco, CA 94114, Amerikai Egyesült Államok) – a jelentkezésekről és üzenetekről szóló értesítő e-mailek kézbesítése az adatkezelő részére;",
        "<b>Hírlevél-szolgáltatás:</b> MailerLite Limited (88 Harcourt Street, Dublin 2, D02 DK18, Írország) – a hírlevél-feliratkozók adatainak kezelése, a megerősítő levelek és hírlevelek kiküldése;",
        "<b>Időpontfoglalás:</b> Calendly LLC (115 E Main St., Ste A1B, Buford, GA 30518, Amerikai Egyesült Államok) – a konzultációs időpontfoglalások kezelése.",
      ]},
    ],
  },
  {
    id: "youtube",
    title: "9. Beágyazott YouTube-videók",
    paragraphs: [
      "A weboldalon beágyazott YouTube-videók találhatók. A beágyazás a YouTube adatvédelmi szempontból kiterjesztett (youtube-nocookie.com) módjával történik. A videó előnézeti képe a weboldal saját tárhelyéről töltődik be. A YouTube lejátszója csak a lejátszás gomb megnyomására, a látogató döntése alapján töltődik be; ekkor a YouTube szolgáltatója, a Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Írország) önálló adatkezelőként technikai adatokat (pl. IP-cím, böngészőadatok) és sütiket kezelhet.",
      "Ezekről az adatkezelésekről a Google adatvédelmi irányelvei adnak tájékoztatást: policies.google.com/privacy.",
    ],
  },
  {
    id: "egt-n-kivuli-tovabbitas",
    title: "10. EGT-n kívüli adattovábbítás",
    paragraphs: [
      "A 8. pontban felsorolt szolgáltatók közül a Cloudflare, az Emergent (Amazon Web Services adatközpont), a Resend és a Calendly az Amerikai Egyesült Államokban kezeli az adatokat, ezért a személyes adatok az Európai Gazdasági Térségen (EGT) kívülre is továbbításra kerülnek.",
      "A Cloudflare, Inc., a Plus Five Five, Inc. (Resend) és a Calendly LLC részt vesz az EU–USA adatvédelmi keretrendszerben (Data Privacy Framework), amelyre az Európai Bizottság megfelelőségi határozatot fogadott el. Az Emergent esetében az adattovábbítás garanciáinak (pl. általános szerződési feltételek) dokumentálása folyamatban van.",
    ],
  },
  {
    id: "megorzes",
    title: "11. Az adatok megőrzése",
    paragraphs: [
      "Az adatkezelő a személyes adatokat csak az adatkezelési cél eléréséhez szükséges ideig kezeli. Az egyes adatkezelési célok szerinti megőrzési idők:",
      { list: [
        "programjelentkezés (aktuális programok): a program időpontját követő 1 évig;",
        "várólista, ha a jelentkező nem kerül át a résztvevők közé: az érintett időpontot követő 30 napig;",
        "élményprogram-jelentkezés: a program befejezését követő 1 évig;",
        "kapcsolatfelvételi üzenet: a beérkezéstől számított 1 évig;",
        "a visszaélés-megelőzéshez rögzített kódolt IP-azonosító: 1 óráig, ezt követően automatikusan törlődik;",
        "hírlevél-feliratkozás: a hozzájárulás visszavonásáig (leiratkozásig);",
        "az adatkezelő értesítő e-mailjei (a jelentkezés adatainak másolata az adatkezelő postafiókjában): az adott jelentkezésre vonatkozó megőrzési idővel azonosan.",
      ]},
      "Ha a jelentkezés alapján szerződés jön létre, és abból igény érvényesítésére kerülhet sor, az adatkezelő az ehhez szükséges adatokat az igény elévüléséig megőrizheti. Az érintett a fenti határidők lejárta előtt is kérheti adatai törlését az adatkezelő e-mail-címén, ha az adatkezelésnek nincs más jogalapja.",
    ],
  },
  {
    id: "sutik",
    title: "12. Sütik (cookie-k)",
    paragraphs: [
      "A weboldal látogatottságmérő, marketing- vagy profilalkotási célú sütit nem használ. Az adminisztrációs felületen kizárólag az adatkezelő bejelentkezéséhez szükséges munkamenet-süti jön létre; ez a látogatókat nem érinti.",
      "A külső szolgáltatások csak a látogató kattintására töltődnek be: a Calendly az időpontfoglalás gombra, a YouTube-videó a lejátszás gombra kattintva. Ezek saját sütiket helyezhetnek el, amelyekről az adott szolgáltató tájékoztatója ad részletes információt.",
      "A sütiket az érintett a böngészője beállításaiban bármikor törölheti vagy letilthatja. A sütik letiltása befolyásolhatja egyes funkciók (pl. időpontfoglalás, videólejátszás) működését.",
    ],
  },
  {
    id: "adatbiztonsag",
    title: "13. Adatbiztonság",
    paragraphs: [
      "Az adatkezelő megfelelő technikai és szervezési intézkedésekkel gondoskodik a személyes adatok biztonságáról. A weboldal és a háttérrendszer közötti kommunikáció titkosított (HTTPS) kapcsolaton keresztül történik, a jelentkezési adatokat az adatkezelő jelszóval védett adminisztrációs felületen kezeli, amelyhez rajta kívül más nem rendelkezik hozzáféréssel.",
      "Az adatkezelő a személyes adatokat harmadik félnek nem adja át, kivéve a jelen Tájékoztatóban megnevezett adatfeldolgozókat, illetve ha erre jogszabály kötelezi.",
    ],
  },
  {
    id: "erintettek-jogai",
    title: "14. Az érintettek jogai",
    paragraphs: [
      "Az érintett a GDPR alapján az alábbi jogokkal rendelkezik:",
      { list: [
        "tájékoztatáshoz és hozzáféréshez való jog: tájékoztatást és másolatot kérhet a róla kezelt személyes adatokról;",
        "helyesbítéshez való jog: kérheti pontatlan vagy hiányos adatai helyesbítését, kiegészítését;",
        "törléshez való jog: a GDPR-ban meghatározott feltételek fennállása esetén kérheti adatai törlését;",
        "az adatkezelés korlátozásához való jog;",
        "adathordozhatósághoz való jog: a hozzájáruláson vagy szerződésen alapuló adatkezelés esetén kérheti adatai tagolt, széles körben használt, géppel olvasható formátumban történő kiadását;",
        "tiltakozáshoz való jog: a jogos érdeken alapuló adatkezelés ellen tiltakozhat;",
        "a hozzájárulás visszavonásához való jog: a hozzájáruláson alapuló adatkezeléshez adott hozzájárulását bármikor visszavonhatja, ami nem érinti a visszavonás előtti adatkezelés jogszerűségét.",
      ]},
      "A jogok gyakorlására irányuló kérelmet a szasztotheniko.office@gmail.com e-mail-címen vagy postai úton (4002 Debrecen, Kárpáti Károly utca 3.) lehet benyújtani. Az adatkezelő a kérelemre indokolatlan késedelem nélkül, legfeljebb egy hónapon belül válaszol.",
    ],
  },
  {
    id: "jogorvoslat",
    title: "15. Jogorvoslati lehetőségek",
    paragraphs: [
      "Az érintett a személyes adatai kezelésével kapcsolatban panaszt tehet közvetlenül az adatkezelőnél, illetve panaszával fordulhat a felügyeleti hatósághoz:",
      { list: [
        "Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)",
        "Cím: 1055 Budapest, Falk Miksa utca 9–11.",
        "Levelezési cím: 1363 Budapest, Pf. 9.",
        "Telefon: +36 (30) 683-5969",
        "E-mail: ugyfelszolgalat@naih.hu",
        "Weboldal: www.naih.hu",
      ]},
      "Az érintett jogainak megsértése esetén bírósághoz is fordulhat. A per – az érintett választása szerint – a lakóhelye vagy tartózkodási helye szerinti törvényszék előtt is megindítható.",
    ],
  },
  {
    id: "modositas",
    title: "16. A Tájékoztató módosítása",
    paragraphs: [
      "Az adatkezelő fenntartja a jogot a jelen Tájékoztató módosítására. A módosított Tájékoztató a weboldalon történő közzététellel lép hatályba.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <main
      data-testid="privacy-policy-page"
      className="bg-warm text-graphite min-h-screen"
    >
      <Header />
      <div className="pt-24 md:pt-28" />

      {/* Hero */}
      <section
        data-testid="privacy-hero"
        className="px-6 md:px-10 py-14 md:py-18"
      >
        <div className="max-w-2xl mx-auto text-center">
          <h1
            data-testid="privacy-title"
            className="font-serif-display text-[36px] sm:text-[44px] md:text-[52px] leading-[1.15] text-graphite tracking-tight mb-6"
          >
            Adatkezelési{" "}
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              tájékoztató
            </em>
          </h1>
          <p className="font-body font-light text-[13px] tracking-[0.28em] uppercase text-muted-warm">
            Utolsó frissítés · {LAST_UPDATED}
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="px-6 md:px-10 pb-16 md:pb-20"><div className="max-w-5xl mx-auto">
        {SECTIONS.map((section, i) => (
          <article
            key={section.id}
            id={section.id}
            data-testid={`privacy-section-${section.id}`}
            className={`py-10 md:py-12 ${i > 0 ? "border-t border-hairline" : ""}`}
          >
            <h2 className="font-serif-display text-graphite text-[22px] md:text-[26px] leading-[1.3] mb-6 md:mb-8">
              {section.title}
            </h2>
            <div className="reading-prose font-body font-light text-[16px] md:text-[17px] leading-[1.9] text-graphite space-y-5">
              {section.paragraphs.map((p, idx) => {
                if (typeof p === "string") {
                  return <PrivacyParagraph key={idx} text={p} />;
                }
                if (p.list) {
                  return (
                    <ul key={idx} className="list-none pl-0 space-y-2.5">
                      {p.list.map((item, li) => (
                        <li key={li} className="flex gap-3 leading-[1.75]">
                          <span
                            aria-hidden="true"
                            className="text-gold flex-shrink-0 mt-[2px]"
                          >
                            ›
                          </span>
                          <PrivacyInline text={item} />
                        </li>
                      ))}
                    </ul>
                  );
                }
                return null;
              })}
            </div>
          </article>
        ))}
      </div></div>

      <PageFooter />
    </main>
  );
}

/* ------------------------------------------------------------------ */
/* Rendering helpers — handle [[PLACEHOLDER]] highlighting + <b> tags */
/* ------------------------------------------------------------------ */

const PLACEHOLDER = /\[\[([^\]]+)\]\]/g;
const BOLD = /<b>([^<]+)<\/b>/g;

function renderInline(text) {
  // Split by placeholders first, then handle <b> inside string parts.
  const parts = [];
  let lastIdx = 0;
  let m;
  while ((m = PLACEHOLDER.exec(text)) !== null) {
    if (m.index > lastIdx) parts.push({ kind: "text", value: text.slice(lastIdx, m.index) });
    parts.push({ kind: "ph", value: m[1] });
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) parts.push({ kind: "text", value: text.slice(lastIdx) });

  return parts.map((p, i) => {
    if (p.kind === "ph") {
      return (
        <span
          key={i}
          data-testid="privacy-placeholder"
          className="inline-block px-2 py-0.5 bg-tinted text-gold font-body font-normal text-[13.5px] tracking-[0.05em] border border-gold/40 rounded"
          title="Kitöltendő adat"
        >
          {p.value}
        </span>
      );
    }
    // handle <b>...</b>
    const chunks = [];
    let last = 0;
    let bm;
    while ((bm = BOLD.exec(p.value)) !== null) {
      if (bm.index > last) chunks.push(p.value.slice(last, bm.index));
      chunks.push(<strong key={`b-${i}-${last}`}>{bm[1]}</strong>);
      last = bm.index + bm[0].length;
    }
    if (last < p.value.length) chunks.push(p.value.slice(last));
    return <React.Fragment key={i}>{chunks}</React.Fragment>;
  });
}

function PrivacyParagraph({ text }) {
  return <p>{renderInline(text)}</p>;
}

function PrivacyInline({ text }) {
  return <span>{renderInline(text)}</span>;
}
